import { render, staticRenderFns } from "./newsrotate.vue?vue&type=template&id=0165a7e1&scoped=true&"
import script from "./newsrotate.vue?vue&type=script&lang=js&"
export * from "./newsrotate.vue?vue&type=script&lang=js&"
import style0 from "./newsrotate.vue?vue&type=style&index=0&id=0165a7e1&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165a7e1",
  null
  
)

export default component.exports